export const blockIconsHomeBroadcastOnPersonal = (
	<span className='material-symbols-outlined'>broadcast_on_personal</span>
);
